<template>
  <div class="ma-4">
    <add-finance-dialog
      ref="transaction"
      :clientID="clientID"
      :financeID="financeID"
      :isAuditorRole="isAuditorRole"
      @get-finance-transactions="fetch"
    />
    <ClientNav navigateTo="Finances" />

    <v-row dense>
      <v-col cols="12" lg="3" xl="2">
        <finance-side
          :financeItemData="$store.state.finances.items"
          :financeID="financeID"
        />
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-row dense>
          <v-col cols="12" md="12">
            <v-spacer></v-spacer>
            <v-row>
              <v-card-actions>
                <v-list-item class="grow">
                  <v-list-item-avatar color="grey darken-3">
                    <v-img
                      class="elevation-6"
                      alt=""
                      :src="client.image"
                    ></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{ client.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card-actions>

              <v-row justify="end">
                <div class="ma-1 mr-n1">
                  <v-menu offset-y>
                    <template v-slot:activator="{ attrs, on }">
                      <v-btn
                        class="white--text ma-5"
                        v-bind="attrs"
                        v-on="on"
                        color="blue-grey"
                        :loading="isDownloading || isLoading"
                        :disabled="isDownloading || isLoading"
                      >
                        Download
                        <v-icon right dark> mdi-cloud-download </v-icon>
                        <template v-slot:loader>
                          <v-progress-linear
                            :height="36"
                            :value="downloadProgressValue"
                            color="primary"
                            striped
                          >
                            <strong>{{ downloadProgressValue }}%</strong>
                          </v-progress-linear>
                        </template>
                      </v-btn>
                    </template>

                    <v-list class="pa-0">
                      <v-list-item
                        v-for="(item, index) in reportItems"
                        :key="index"
                        link
                      >
                        <v-list-item-title
                          v-text="item.title"
                          @click="download(item.name)"
                        ></v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
                <div class="ma-4 ml-n2" v-if="!isAuditorRole">
                  <v-btn
                    v-if="!closeOut"
                    color="#2b3990"
                    dark
                    class="mb-2 mt-2 mr-2"
                    @click="showAdd()"
                  >
                    <v-icon left>add</v-icon>
                    New Finance
                  </v-btn>

                  <v-chip
                    v-else
                    class="mb-2 mt-2 mr-2"
                    color="error"
                    label
                    outlined
                  >
                    CLOSED
                  </v-chip>

                  <!-- <v-btn v-else class="mb-2 mt-2 mr-2" outlined color="error">
                    closed
                  </v-btn> -->
                </div>
              </v-row>
            </v-row>

            <v-card elevation="0" outlined>
              <v-toolbar flat>
                <template v-slot:extension>
                  <v-tabs v-model="tabs" align-with-title>
                    <v-tabs-slider color="blue"></v-tabs-slider>
                    <v-tab
                      v-for="item in items"
                      :key="item.id"
                      @click="selectTab(item)"
                    >
                      {{ item.name }}
                    </v-tab>
                  </v-tabs>
                </template>
              </v-toolbar>

              <v-tabs-items v-model="tabs">
                <v-tab-item v-for="item in items" :key="item.id">
                  <v-card flat>
                    <v-data-table
                      :headers="headers"
                      sort-asc
                      :items="finances"
                      :item-class="rowColor"
                      loading-text="Loading Finances"
                      height="475"
                      :loading="isLoading"
                    >
                      <template v-slot:item.ClientSignature="{ item }">
                        <v-img
                          max-height="50"
                          max-width="50"
                          :src="item.ClientSignature"
                          @click="clientSignatureDialog = true, clientSignature = item.ClientSignature"
                        ></v-img>
                      </template>
                      <template v-slot:item.actions="{ item }" v-if="!closeOut">
                        <v-icon small class="mr-2" @click="viewFinance(item)">
                          mdi-eye
                        </v-icon>
                        <v-icon
                          v-if="userRole && !isAuditorRole"
                          small
                          @click="
                            deleteFinance(item);
                            $event.stopPropagation();
                          "
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                    <v-dialog
                      v-model="clientSignatureDialog"
                      max-width="500"
                      max-height="600"
                    >
                      <v-card
                        class=""
                        max-width="500"
                        max-height="600"
                      >
                        <v-card-title class="grey lighten-4 my-auto">
                          <v-spacer></v-spacer>
                          <v-btn
                            color="grey darken-3"
                            elevation="1"
                            icon
                            small
                            @click="clientSignatureDialog = false"
                          >
                            <v-icon>
                              mdi-close
                            </v-icon>
                          </v-btn>
                        </v-card-title>
                        <v-card-text class="pa-auto">
                          <v-img
                            class="mx-auto"
                            width="400"
                            height="300"
                            :src="clientSignature"
                          >
                          </v-img>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <Foot />
  </div>
</template>

<script>
/*eslint-disable */
import ClientNav from "../../components/ClientNav";
import ClientSide from "../../components/ClientSide";
import Foot from "../../components/Footer";
import AddFinanceDialog from "@/components/finances/AddFinanceDialog";
import FinanceSide from "@/components/finances/FinanceSide";
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import download from "downloadjs";

export default {
  props: {
    base: {
      type: String,
      default: () => "",
    },
  },
  components: {
    ClientNav,
    ClientSide,
    AddFinanceDialog,
    FinanceSide,
    Foot,
  },
  data() {
    return {
      dialog: true,
      show: null,
      search: "",
      headers: [
        {
          text: "Date",
          align: "start",
          sortable: false,
          value: "Date",
        },
        { text: "Type", value: "TransactionType" },
        { text: "Method", value: "TransactionMethods" },
        { text: "Payee", value: "Payee" },
        { text: "($)Amount", value: "Amount.$numberDecimal" },
        { text: "($)Balance", value: "roundRunningTotal" },
        { text: "Notes", value: "Notes" },
        { text: "Client Signature", value: "ClientSignature" },
        { text: "Staff Signature", value: "StaffSignature" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      loading: false,
      selection: 1,
      datePeriod: "",
      currentBalance: 0,
      clientID: this.$route.params.clientID,
      financeID: this.$route.query.financeID,
      tabs: 0,
      items: [
        { index: 0, name: "Debit Card" },
        { index: 1, name: "EBT" },
        { index: 2, name: "Cash" },
      ],
      selectedTab: null,
      reportItems: [
        { title: "Cash Report", name: "Cash" },
        { title: "EBT Report", name: "EBT" },
        { title: "Debit Card Report", name: "Debit Card" },
      ],
      isDownloading: false,
      closeOut: false,
      isLoading: false,
      finances: [],
      transactionMethod: "Cash",

      clientSignatureDialog: false,
      clientSignature: ""
    };
  },

  beforeRouteUpdate(to, from, next) {
    if (to.path === from.path) {
      this.finances = [];
    }
    next();
  },

  created() {
    // let closeOut = [null, ""];

    // if (closeOut.includes(this.$store.state.finances.CloseOut)) {
    //   return this.$router.go(-1);
    // }
    this.getClientInfo(this.clientID);
    this.fetch();
  },

  mounted() {
    let tab = this.items.findIndex(
      (item) => item.name === this.$route.query.type
    );
    this.tabs = tab;
  },

  computed: {
    ...mapState({
      downloadProgressValue: state => state.financeTransactions.downloadProgressValue
    }),

    userRole() {
      const roles = [
        "Administration",
        "Program Coordinator",
        "Client Services Manager",
      ];
      return roles.includes(this.$store.state.users.user.Role);
    },

    client() {
      return {
        name: this.$store.state.clients?.client?.Name,
        image: this.$store.state.clients?.client?.Image,
      };
    },

    isAuditorRole() {
       return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  methods: {
    ...mapActions({
      getFinanceTransactions: "financeTransactions/getFinanceTransactions",
      getFinance: "finances/getFinance",
      getClientFinances: "finances/getClientFinances",
      downloadReport: "financeTransactions/downloadReport",
      getClientInfo: "clients/getClient",
    }),

    ...mapMutations({
      setFinanceDialog: "financeTransactions/SET_FINANCE_DIALOG",
      setdownloadProgressValue: "financeTransactions/SET_DOWNLOAD_PROGRESS_VALUE",
    }),

    showAdd() {
      this.setFinanceDialog(true);
    },

    viewFinance(item) {
      this.$refs.transaction.onViewItem({
        ...item,
        Month: this.$store.state.finances.items[0].Month,
        ClientName: this.$store.state.finances.items[0].ClientName,
      });
      this.setFinanceDialog(true);
    },

    deleteFinance(item) {
      let confirmDeletion = confirm(
        "Are you sure you want to delete this finance?"
      );
      if (confirmDeletion) {
        this.$store.dispatch(
          "financeTransactions/deleteFinanceTransaction",
          item._id
        );
        this.fetch();
      }
    },

    async selectTab(tab) {
      this.selectedTab = tab;

      let data = this.query(this.$route.query.financeID, tab.name);

      this.$router.push({
        path: this.$route.path,
        query: { financeID: this.$route.query.financeID, type: tab.name },
      });
      this.finances = await this.getFinanceTransactions(data);
    },

    query(id, type) {
      const data = {
        financeID: id,
        transactionMethods: type,
      };
      return data;
    },

    async fetch() {
      this.isLoading = true;
      this.transactionMethod = this.$route.query.type;
      let data = this.query(
        this.$route.query.financeID,
        this.transactionMethod
      );
      try {
        const response = await this.getClientFinances(this.clientID);
        this.finances = await this.getFinanceTransactions(data);
        let finance = response.find(
          (item) => item._id === this.$route.query.financeID
        );
        this.closeOut = finance.CloseOut;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async download(type) {
      this.isDownloading = true;
      const data = {
        financeID: this.$route.query.financeID,
        transactionMethods: type,
      };

      try {
        // const response = await this.downloadReport(data);

        // if(response.data.length === 0){
        //    this.isDownloading = false;
        //   return alert(response.message);
        // }

        // let pdfFile = "data:application/octet-stream;base64," + response.data;
        
        // download(pdfFile, "finance-report.pdf", "application/pdf");

        // Percentage of progress in downloading pdf.
        this.setdownloadProgressValue(0)
        var progress = 0
        var intv = setInterval(() => {
          if (this.downloadProgressValue > progress || progress > 98) {
            clearInterval(intv);
          } else {
            progress += 1;
            this.setdownloadProgressValue(progress)
          }
        }, 1000)

        await this.downloadReport(data).then((response) => {

          // set the blog type to final pdf
          const blob = new Blob([response.data], {type: 'application/pdf'})

          // process to auto download it
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `finance-report.pdf`
          link.click()
        })

        this.isDownloading = false;
      } catch (error) {
        console.log(error);
        this.isDownloading = false;
      }
    },

    rowColor(item) {
      if (
        item.DepositCategory === "Rollover" ||
        item.ExpenseCategory === "Rollover"
      ) {
        return "blue lighten-4";
      }
      return item.TransactionType == "Deposit" ? "Green" : "Red";
    },
  },
};
</script>

<style scoped>
.v-toolbar__content {
  height: 20px !important;
}

.v-chip.v-size--default {
  height: 37px;
}
</style>
